import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { ArrowLeft, Heart, Upload, Loader2 } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminShokhCreatePage() {
  const { token, isAuthenticated, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [states, setStates] = useState([]);
  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: '', age: '', date_of_death: '', date_of_birth: '',
    village: '', city: '', state: '', family_name: '', message: ''
  });

  useEffect(() => {
    if (!authLoading && !isAuthenticated) navigate('/admin');
  }, [isAuthenticated, authLoading, navigate]);

  useEffect(() => {
    axios.get(`${API}/api/states`).then(r => setStates(r.data)).catch(() => {});
  }, []);

  const handlePhoto = (e) => {
    const file = e.target.files[0];
    if (file) { setPhoto(file); const r = new FileReader(); r.onloadend = () => setPhotoPreview(r.result); r.readAsDataURL(file); }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.date_of_death || !form.city || !form.state || !form.message || !photo) {
      toast.error('सभी आवश्यक फ़ील्ड भरें'); return;
    }
    setLoading(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (v) fd.append(k, v); });
      fd.append('photo', photo);
      await axios.post(`${API}/api/admin/shokh-sandesh/create`, fd, {
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${token}` }
      });
      toast.success('शोक संदेश प्रकाशित!');
      navigate('/admin/dashboard');
    } catch (err) { toast.error(err.response?.data?.detail || 'Error'); }
    finally { setLoading(false); }
  };

  return (
    <div className="pb-24 md:pb-12" data-testid="admin-shokh-create">
      <div className="max-w-2xl mx-auto px-4 py-6 md:py-10">
        <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 mb-6">
          <ArrowLeft className="w-4 h-4" />वापस
        </button>
        <div className="flex items-center gap-3 mb-6">
          <Heart className="w-7 h-7 text-gray-900" fill="currentColor" />
          <h1 className="font-outfit font-bold text-2xl text-gray-900">शोक संदेश बनाएं (Admin)</h1>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">फोटो *</label>
            <div className="flex items-center gap-4">
              <div className="w-28 h-28 rounded-xl border-2 border-dashed border-gray-300 flex items-center justify-center overflow-hidden bg-gray-50">
                {photoPreview ? <img src={photoPreview} alt="" className="w-full h-full object-cover" /> : <Upload className="w-8 h-8 text-gray-400" />}
              </div>
              <div>
                <input type="file" accept="image/*" onChange={handlePhoto} className="hidden" id="admin-shokh-photo" />
                <label htmlFor="admin-shokh-photo" className="cursor-pointer inline-block px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-xl text-sm font-medium">{photo ? 'बदलें' : 'फोटो चुनें'}</label>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm font-medium mb-1">नाम *</label><input value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none focus:ring-2 focus:ring-gray-900" placeholder="दिवंगत का नाम" /></div>
            <div><label className="block text-sm font-medium mb-1">उम्र</label><input value={form.age} onChange={e => setForm({...form, age: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none focus:ring-2 focus:ring-gray-900" placeholder="65 वर्ष" /></div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div><label className="block text-sm font-medium mb-1">निधन तिथि *</label><input type="date" value={form.date_of_death} onChange={e => setForm({...form, date_of_death: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none focus:ring-2 focus:ring-gray-900" /></div>
            <div><label className="block text-sm font-medium mb-1">जन्म तिथि</label><input type="date" value={form.date_of_birth} onChange={e => setForm({...form, date_of_birth: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none focus:ring-2 focus:ring-gray-900" /></div>
          </div>
          <div><label className="block text-sm font-medium mb-1">परिवार</label><input value={form.family_name} onChange={e => setForm({...form, family_name: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none" placeholder="शर्मा परिवार" /></div>
          <div className="grid grid-cols-3 gap-4">
            <div><label className="block text-sm font-medium mb-1">गाँव</label><input value={form.village} onChange={e => setForm({...form, village: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none" /></div>
            <div><label className="block text-sm font-medium mb-1">शहर *</label><input value={form.city} onChange={e => setForm({...form, city: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none" /></div>
            <div><label className="block text-sm font-medium mb-1">राज्य *</label>
              <select value={form.state} onChange={e => setForm({...form, state: e.target.value})} className="w-full px-4 py-3 border rounded-xl text-sm outline-none bg-white">
                <option value="">चुनें</option>{states.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
          </div>
          <div><label className="block text-sm font-medium mb-1">श्रद्धांजलि *</label><textarea value={form.message} onChange={e => setForm({...form, message: e.target.value})} rows={4} className="w-full px-4 py-3 border rounded-xl text-sm outline-none resize-none focus:ring-2 focus:ring-gray-900" placeholder="श्रद्धांजलि संदेश..." /></div>
          <Button type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-gray-900 hover:bg-gray-800">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'प्रकाशित करें'}
          </Button>
        </form>
      </div>
    </div>
  );
}
